import { TypedUseSelectorHook, useSelector } from 'react-redux';
import type { RootState } from '../store';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useCartSelectors = () => {
  const appSelector = useAppSelector;

  return {
    isLoading: appSelector((state: RootState) => state.cart.loader),
    isCartOpen: appSelector((state: RootState) => state.cart.isCartOpen),
    cartProducts: appSelector((state: RootState) => state.cart.cartProducts),
    totalPrice: appSelector((state: RootState) => state.cart.finalPrice),
    totalSavings: appSelector((state: RootState) => state.cart.totalSavings),
    subTotal: appSelector((state: RootState) => state.cart.subTotal),
    productsQuantity: appSelector((state: RootState) => state.cart.productsQuantity),
    withShippingProtection: appSelector((state: RootState) => state.cart.withShippingProtection),
    freeShippingPrice: appSelector((state: RootState) => state.cart.freeShippingPrice),
    CartData: appSelector((state: RootState) => state.cart),
    hasFreeShipping: appSelector((state: RootState) => state.cart.hasFreeShipping),
    LazyLoad: appSelector((state: RootState) => state.cart.loadLazyComponents),
    cartProductsQuantity: appSelector((state: RootState) => state.cart.productsQuantity),
    warrantyProduct: appSelector((state: RootState) => state.cart.warrantyProduct),
    shipping: appSelector((state: RootState) => state.cart.shipping),
  };
};
